<script>
  import { describeStopReason } from "../utils/stopReason.js";

  // "Why it ended", shared VERBATIM by the live panel and the read-only archive
  // so reloading a run can never downgrade the plain-English explanation back to
  // the bare gem string.
  export let errorMessage = null;
  // The container's test id differs by host (the archive's is asserted by
  // existing specs); the inner ids are the same in both, and only one of the two
  // hosts is ever mounted at a time.
  export let testid = "run-why-ended";

  $: reason = describeStopReason(errorMessage);
</script>

{#if reason}
  <!-- Every line wraps. `error_message` is not a curated string: the gem slices
       a failing provider response body straight into it (response_parsing.rb),
       so a single 800-char unbroken token of minified JSON is the NORMAL shape.
       Without overflow-wrap:anywhere that one line stretches the whole document
       (measured: 7391px against a 1440px viewport) and breaks every column on
       the page. whitespace-pre-wrap keeps a multi-line reason multi-line. -->
  <div
    class="bg-danger-bg text-danger-text border border-danger-border/20 rounded px-2.5 py-2 text-xs space-y-1 min-w-0"
    role="alert"
    data-testid={testid}
  >
    <span class="font-bold uppercase tracking-wider text-[0.6rem]">Why it ended</span>
    <p
      class="font-semibold whitespace-pre-wrap [overflow-wrap:anywhere]"
      data-testid="run-why-ended-headline"
    >{reason.headline}</p>
    {#if reason.detail}
      <p class="opacity-90 [overflow-wrap:anywhere]" data-testid="run-why-ended-detail">
        {reason.detail}
      </p>
    {/if}
    <!-- The run's own string, verbatim: never dropped, however it reads. -->
    <!-- Complete and verbatim, but height-capped: an 800-char provider body is
         ~20 lines of hex, and the block must not swallow the page. It scrolls,
         so every character is still there to read and copy. -->
    <p
      class="font-mono text-[0.65rem] opacity-75 whitespace-pre-wrap [overflow-wrap:anywhere] max-h-24 overflow-y-auto"
      data-testid="run-why-ended-raw"
    >{reason.raw}</p>
  </div>
{/if}
